"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var BooleanEncoder=function(){function e(){}return e.encode=function(e){return+e+""},e.decode=function(e){return"1"===e},e}();exports.BooleanEncoder=BooleanEncoder;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@iabtcf/core/lib/encoder/field/BooleanEncoder.js
// module id = 6
// module chunks = 0